import { LcvModel } from '@/services/contentstack/models/lcv-model';

export const MU_X_CLASS = 'blt46d60158aacbf5e6';
export const PICK_UP_2_DOOR_CLASS = 'blte481ba899a693b47';
export const PICK_UP_4_DOOR_CLASS = 'bltef31289b74d6e9af';
export const SPARK_CLASS = 'blt904fe36f8eae814e';
export const V_CROSS_CLASS = 'blteabba7c8f54ca22b';
export const X_SERIES_CLASS = 'bltd4aeddedceaca9ca';
export type ILCVModelCategory =
  | typeof MU_X_CLASS
  | typeof PICK_UP_2_DOOR_CLASS
  | typeof PICK_UP_4_DOOR_CLASS
  | typeof SPARK_CLASS
  | typeof V_CROSS_CLASS
  | typeof X_SERIES_CLASS;

export const HILANDER_SUB_CATEGORY = 'blte0a3414e1a81c4ff';
export const CAB4_SUB_CATEGORY = 'blt63fcdbab06f03d2c';
export const SPACECAB_SUB_CATEGORY = 'blt60829053483052d9';
export const SPEED_SUB_CATEGORY = 'bltb51b29f7cb609320';
export type ILCVModelSubCategory =
  | typeof HILANDER_SUB_CATEGORY
  | typeof CAB4_SUB_CATEGORY
  | typeof SPACECAB_SUB_CATEGORY
  | typeof SPEED_SUB_CATEGORY;

const UID_V_CROSS_30_Z_2_DOOR_MT_2024_1 = 'bltceb1a83099266c94';
const UID_V_CROSS_30_Z_4_DOOR_MT_2024_1 = 'blt6acc041c24e8448a';
const UID_V_CROSS_30_ZP_4_DOOR_MT_2024_1 = 'bltc78d081e07d16fe4';
export const UID_V_CROSS_30_M_4_DOOR_MT_2024_1 = 'blt01176b7382f3ec9b';

const UID_V_CROSS_30_Z_2_DOOR_MT_2024_1_E5 = 'blt4dd292958753d479';
const UID_V_CROSS_30_Z_4_DOOR_MT_2024_1_E5 = 'blt86cf4310d652b484';
const UID_V_CROSS_30_ZP_4_DOOR_MT_2024_1_E5 = 'blt330e4ba9ee05c7e3';
const UID_V_CROSS_30_M_4_DOOR_MT_2024_1_E5 = 'blt27b4709755a95587';

const UID_V_CROSS_30_Z_2_DOOR_MT_2025_1 = 'blt7a4735078e3e062c';
const UID_V_CROSS_30_Z_4_DOOR_MT_2025_1 = 'bltba1b5575d816e0d1';
const UID_V_CROSS_30_ZP_4_DOOR_MT_2025_1 = 'blt318cba88fd31275d';
const UID_V_CROSS_30_ZP_4_DOOR_AT_2025_1 = 'blte76dbc8ad63f2dee';
const UID_V_CROSS_30_M_4_DOOR_AT_2025_1 = 'blt6d4acb9b2fa33e1f';

export const UID_V_CROSS_ORDER = [
  UID_V_CROSS_30_Z_2_DOOR_MT_2024_1,
  UID_V_CROSS_30_Z_4_DOOR_MT_2024_1,
  UID_V_CROSS_30_ZP_4_DOOR_MT_2024_1,
  UID_V_CROSS_30_M_4_DOOR_MT_2024_1,
  UID_V_CROSS_30_Z_2_DOOR_MT_2024_1_E5,
  UID_V_CROSS_30_Z_4_DOOR_MT_2024_1_E5,
  UID_V_CROSS_30_ZP_4_DOOR_MT_2024_1_E5,
  UID_V_CROSS_30_M_4_DOOR_MT_2024_1_E5,
  UID_V_CROSS_30_Z_2_DOOR_MT_2025_1,
  UID_V_CROSS_30_Z_4_DOOR_MT_2025_1,
  UID_V_CROSS_30_ZP_4_DOOR_MT_2025_1,
  UID_V_CROSS_30_ZP_4_DOOR_AT_2025_1,
  UID_V_CROSS_30_M_4_DOOR_AT_2025_1,
];

const UID_4_DOOR_CAB4_19_S_MT_2024_1 = 'blt09a49757fa8442f3';
const UID_4_DOOR_CAB4_19_S_AT_2024_1 = 'bltb4a589e1bd29d285';
const UID_4_DOOR_CAB4_19_L_MT_2024_1 = 'bltb3691f546f630f28';
const UID_4_DOOR_CAB4_19_L_AT_2024_1 = 'bltea295d0d8b566391';
export const UID_4_DOOR_CAB4_19_Z_MT_2024_1 = 'blt6f3e29cce9bcb579';
const UID_4_DOOR_HILANDER_19_L_MT_2024_1 = 'bltf9594fa802c221e0';
const UID_4_DOOR_HILANDER_19_L_AT_2024_1 = 'blt5155fe74388c0d0a';
const UID_4_DOOR_HILANDER_19_Z_MT_2024_1 = 'blt5c394afc3e84dcaa';
const UID_4_DOOR_HILANDER_19_Z_AT_2024_1 = 'bltd5198acfc4d004e0';
const UID_4_DOOR_HILANDER_19_ZP_MT_2024_1 = 'bltbb778dfe895c3079';
const UID_4_DOOR_HILANDER_19_ZP_AT_2024_1 = 'blt1f048db696f432ee';
const UID_4_DOOR_HILANDER_19_M_AT_2024_1 = 'bltfcf014fff3aa77a1';
const UID_4_DOOR_HILANDER_30_ZP_MT_2024_1 = 'blt38c4873b2be9f98e';
export const UID_4_DOOR_HILANDER_30_M_AT_2024_1 = 'blt132b7b08fe96d817';

const UID_4_DOOR_CAB4_19_S_MT_2024_1_E5 = 'blt2bfab4a74cabc3a0';
const UID_4_DOOR_CAB4_19_S_AT_2024_1_E5 = 'bltf832a4d96443ca33';
const UID_4_DOOR_CAB4_19_L_MT_2024_1_E5 = 'blt1c1747d116c35e48';
const UID_4_DOOR_CAB4_19_L_AT_2024_1_E5 = 'blt44264baef663e4bb';
const UID_4_DOOR_CAB4_19_Z_MT_2024_1_E5 = 'blt2bd9460e69536f9e';
const UID_4_DOOR_HILANDER_19_L_MT_2024_1_E5 = 'blt6f60b9890c7a081d';
const UID_4_DOOR_HILANDER_19_L_AT_2024_1_E5 = 'bltcf9fb66ef5294670';
const UID_4_DOOR_HILANDER_19_Z_MT_2024_1_E5 = 'blt74a6546446fb3f0a';
const UID_4_DOOR_HILANDER_19_Z_AT_2024_1_E5 = 'bltb69cad0af827eba8';
const UID_4_DOOR_HILANDER_19_ZP_MT_2024_1_E5 = 'blt9032cd62e049ca5f';
const UID_4_DOOR_HILANDER_19_ZP_AT_2024_1_E5 = 'blt40640c438d80c64d';
const UID_4_DOOR_HILANDER_19_M_AT_2024_1_E5 = 'bltbe8ad7d63c0731a5';
const UID_4_DOOR_HILANDER_19_MHEV_M_AT_2024_1_E5 = 'blt6c77af09358c2820';
const UID_4_DOOR_HILANDER_30_ZP_MT_2024_1_E5 = 'blt37bb70b8fd058cec';
const UID_4_DOOR_HILANDER_30_M_AT_2024_1_E5 = 'bltef92e50d8ea1bdc3';

const UID_4_DOOR_CAB4_22_S_MT_2025_1 = 'blt95513324756477a9';
const UID_4_DOOR_CAB4_22_S_AT_2025_1 = 'blt7ac8139a8e0fdc01';
const UID_4_DOOR_CAB4_19_S_MHEV_AT_2025_1 = 'blt9ef91bfb27762a19';
const UID_4_DOOR_CAB4_22_L_MT_2025_1 = 'blt4309eb0910c623a1';
const UID_4_DOOR_CAB4_22_L_AT_2025_1 = 'blteafc2b22e4f19e11';
export const UID_4_DOOR_CAB4_22_Z_MT_2025_1 = 'blt45f86fbc65339702';
const UID_4_DOOR_HILANDER_22_L_MT_2025_1 = 'blt5c2f42bb2a2f2daa';
const UID_4_DOOR_HILANDER_22_L_AT_2025_1 = 'blt59ae5986737d13c0';
const UID_4_DOOR_HILANDER_22_Z_MT_2025_1 = 'bltd0e07aa7c3dc6616';
const UID_4_DOOR_HILANDER_22_Z_AT_2025_1 = 'blt4466e7466c31c859';
const UID_4_DOOR_HILANDER_22_ZP_MT_2025_1 = 'bltc3b0e269e0ee75e7';
const UID_4_DOOR_HILANDER_22_ZP_AT_2025_1 = 'bltf89d378bd3063e91';
export const UID_4_DOOR_HILANDER_22_M_AT_2025_1 = 'bltb18bfbb0d0185169';
const UID_4_DOOR_HILANDER_19_MHEV_M_AT_2025_1 = 'blt574610219383b66b';
const UID_4_DOOR_HILANDER_30_ZP_MT_2025_1 = 'blta6624f0087350dfa';
const UID_4_DOOR_HILANDER_30_M_AT_2025_1 = 'blt4ee5b2ed391f1fbd';

export const UID_4_DOOR_ORDER = [
  UID_4_DOOR_CAB4_19_S_MT_2024_1,
  UID_4_DOOR_CAB4_19_S_AT_2024_1,
  UID_4_DOOR_CAB4_19_L_MT_2024_1,
  UID_4_DOOR_CAB4_19_L_AT_2024_1,
  UID_4_DOOR_HILANDER_19_L_MT_2024_1,
  UID_4_DOOR_HILANDER_19_L_AT_2024_1,
  UID_4_DOOR_HILANDER_19_Z_MT_2024_1,
  UID_4_DOOR_HILANDER_19_Z_AT_2024_1,
  UID_4_DOOR_HILANDER_19_ZP_MT_2024_1,
  UID_4_DOOR_HILANDER_19_ZP_AT_2024_1,
  UID_4_DOOR_HILANDER_30_ZP_MT_2024_1,
  UID_4_DOOR_HILANDER_19_M_AT_2024_1,
  UID_4_DOOR_HILANDER_30_M_AT_2024_1,
  UID_4_DOOR_CAB4_19_S_MT_2024_1_E5,
  UID_4_DOOR_CAB4_19_S_AT_2024_1_E5,
  UID_4_DOOR_CAB4_19_Z_MT_2024_1,
  UID_4_DOOR_CAB4_19_L_MT_2024_1_E5,
  UID_4_DOOR_CAB4_19_L_AT_2024_1_E5,
  UID_4_DOOR_CAB4_19_Z_MT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_L_MT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_L_AT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_Z_MT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_Z_AT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_ZP_MT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_ZP_AT_2024_1_E5,
  UID_4_DOOR_HILANDER_30_ZP_MT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_M_AT_2024_1_E5,
  UID_4_DOOR_HILANDER_19_MHEV_M_AT_2024_1_E5,
  UID_4_DOOR_HILANDER_30_M_AT_2024_1_E5,
  UID_4_DOOR_CAB4_22_S_MT_2025_1,
  UID_4_DOOR_CAB4_22_S_AT_2025_1,
  UID_4_DOOR_CAB4_19_S_MHEV_AT_2025_1,
  UID_4_DOOR_CAB4_22_L_MT_2025_1,
  UID_4_DOOR_CAB4_22_L_AT_2025_1,
  UID_4_DOOR_CAB4_22_Z_MT_2025_1,
  UID_4_DOOR_HILANDER_22_L_MT_2025_1,
  UID_4_DOOR_HILANDER_22_L_AT_2025_1,
  UID_4_DOOR_HILANDER_22_Z_MT_2025_1,
  UID_4_DOOR_HILANDER_22_Z_AT_2025_1,
  UID_4_DOOR_HILANDER_22_ZP_MT_2025_1,
  UID_4_DOOR_HILANDER_22_ZP_AT_2025_1,
  UID_4_DOOR_HILANDER_22_M_AT_2025_1,
  UID_4_DOOR_HILANDER_19_MHEV_M_AT_2025_1,
  UID_4_DOOR_HILANDER_30_ZP_MT_2025_1,
  UID_4_DOOR_HILANDER_30_M_AT_2025_1,
];

const UID_2_DOOR_SPACECAB_19_S_MT_2024_1 = 'blt4f7e59129b455c99';
const UID_2_DOOR_SPACECAB_19_S_AT_2024_1 = 'bltf5591db3be9cae56';
const UID_2_DOOR_SPACECAB_30_S_MT_2024_1 = 'bltaac596679abc1eac';
const UID_2_DOOR_SPACECAB_19_L_MT_2024_1 = 'blt658c48791a65440d';
export const UID_2_DOOR_SPACECAB_19_L_AT_2024_1 = 'blt63921ca81c525acd';
const UID_2_DOOR_HILANDER_19_L_MT_2024_1 = 'blt4e56b5a2ddd2ec5d';
const UID_2_DOOR_HILANDER_19_L_AT_2024_1 = 'bltb29fe9fbece29ed3';
const UID_2_DOOR_HILANDER_19_Z_MT_2024_1 = 'blt8e9d1cbbc8c0e1da';
const UID_2_DOOR_HILANDER_19_Z_AT_2024_1 = 'blt002a4fa6c2bc3093';
export const UID_2_DOOR_HILANDER_19_ZP_AT_2024_1 = 'blt32276436b8da0726';

const UID_2_DOOR_SPACECAB_19_S_MT_2024_1_E5 = 'blt0b0d659a935f6f14';
const UID_2_DOOR_SPACECAB_19_S_AT_2024_1_E5 = 'blt9225f90070fa551c';
const UID_2_DOOR_SPACECAB_30_S_MT_2024_1_E5 = 'blt2875e6e86fd69855';
const UID_2_DOOR_SPACECAB_19_L_MT_2024_1_E5 = 'blt06ede20be022fed1';
const UID_2_DOOR_SPACECAB_19_L_AT_2024_1_E5 = 'blt5d9b76d0757aaa50';
const UID_2_DOOR_HILANDER_19_L_MT_2024_1_E5 = 'bltd9fcdad776344cae';
const UID_2_DOOR_HILANDER_19_L_AT_2024_1_E5 = 'blt40a42d41a3dbf177';
const UID_2_DOOR_HILANDER_19_Z_MT_2024_1_E5 = 'blta9db7ceee7a1ed31';
const UID_2_DOOR_HILANDER_19_Z_AT_2024_1_E5 = 'blt53c91820499b270c';
const UID_2_DOOR_HILANDER_19_ZP_AT_2024_1_E5 = 'bltfc6ee9d506ee0747';

const UID_2_DOOR_SPACECAB_22_S_MT_2025_1 = 'bltbcacc1343e56365b';
const UID_2_DOOR_SPACECAB_22_S_AT_2025_1 = 'blt78b96bca1a51a6ca';
const UID_2_DOOR_SPACECAB_30_S_MT_2025_1 = 'blt956dcf2e64d8d2b2';
const UID_2_DOOR_SPACECAB_22_L_MT_2025_1 = 'bltd0d8bb22dde51d72';
const UID_2_DOOR_SPACECAB_22_L_AT_2025_1 = 'blt5015d66ca9d8bd77';
const UID_2_DOOR_HILANDER_22_L_MT_2025_1 = 'blt019e587578ae625d';
const UID_2_DOOR_HILANDER_22_L_AT_2025_1 = 'bltbd638970f091a6f4';
const UID_2_DOOR_HILANDER_22_Z_MT_2025_1 = 'blt86a88e53cb6a028e';
const UID_2_DOOR_HILANDER_22_Z_AT_2025_1 = 'blt0a00b538dfb3fcbe';
const UID_2_DOOR_HILANDER_22_ZP_AT_2025_1 = 'blt8d99b0a00d7debe4';

export const UID_2_DOOR_ORDER = [
  UID_2_DOOR_SPACECAB_19_S_MT_2024_1,
  UID_2_DOOR_SPACECAB_19_S_AT_2024_1,
  UID_2_DOOR_SPACECAB_30_S_MT_2024_1,
  UID_2_DOOR_SPACECAB_19_L_MT_2024_1,
  UID_2_DOOR_SPACECAB_19_L_AT_2024_1,
  UID_2_DOOR_HILANDER_19_L_MT_2024_1,
  UID_2_DOOR_HILANDER_19_L_AT_2024_1,
  UID_2_DOOR_HILANDER_19_Z_MT_2024_1,
  UID_2_DOOR_HILANDER_19_Z_AT_2024_1,
  UID_2_DOOR_HILANDER_19_ZP_AT_2024_1,
  UID_2_DOOR_SPACECAB_19_S_MT_2024_1_E5,
  UID_2_DOOR_SPACECAB_19_S_AT_2024_1_E5,
  UID_2_DOOR_SPACECAB_30_S_MT_2024_1_E5,
  UID_2_DOOR_SPACECAB_19_L_MT_2024_1_E5,
  UID_2_DOOR_SPACECAB_19_L_AT_2024_1_E5,
  UID_2_DOOR_HILANDER_19_L_MT_2024_1_E5,
  UID_2_DOOR_HILANDER_19_L_AT_2024_1_E5,
  UID_2_DOOR_HILANDER_19_Z_MT_2024_1_E5,
  UID_2_DOOR_HILANDER_19_Z_AT_2024_1_E5,
  UID_2_DOOR_HILANDER_19_ZP_AT_2024_1_E5,
  UID_2_DOOR_SPACECAB_22_S_MT_2025_1,
  UID_2_DOOR_SPACECAB_22_S_AT_2025_1,
  UID_2_DOOR_SPACECAB_30_S_MT_2025_1,
  UID_2_DOOR_SPACECAB_22_L_MT_2025_1,
  UID_2_DOOR_SPACECAB_22_L_AT_2025_1,
  UID_2_DOOR_HILANDER_22_L_MT_2025_1,
  UID_2_DOOR_HILANDER_22_L_AT_2025_1,
  UID_2_DOOR_HILANDER_22_Z_MT_2025_1,
  UID_2_DOOR_HILANDER_22_Z_AT_2025_1,
  UID_2_DOOR_HILANDER_22_ZP_AT_2025_1,
];

const UID_SPARK_19_B_FLAT_DECK_MT_2024_1 = 'blt2c4c007be51af6bb';
const UID_SPARK_19_B_CAB_CHASSIS_MT_2024_1 = 'blt429a483a8b9a061e';
const UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_MT_2024_1 = 'blt987219a8d3e53562';
const UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_AT_2024_1 = 'bltb10e7f5753fb9001';
const UID_SPARK_19_B_MT_2024_1 = 'blt53bc04d597cafcf1';
const UID_SPARK_19_S_MT_2024_1 = 'bltd2f62f6d21ea1094';
const UID_SPARK_19_S_AT_2024_1 = 'blt91a1576c0ee49480';
const UID_SPARK_30_S_MT_2024_1 = 'blt00a25161ecf64746';
export const UID_SPARK_4X4_30_S_MT_2024_1 = 'blt35acfba4347679e9';

const UID_SPARK_19_B_FLAT_DECK_MT_2024_1_E5 = 'bltde81ad7e87b87111';
const UID_SPARK_19_B_CAB_CHASSIS_MT_2024_1_E5 = 'bltdbe6b3d9c37fa40c';
const UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_MT_2024_1_E5 =
  'bltc625f823705e106d';
const UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_AT_2024_1_E5 =
  'bltf457a12fdf5d4f9a';
const UID_SPARK_19_B_MT_2024_1_E5 = 'bltc2c0e3e0921e80e6';
const UID_SPARK_19_S_MT_2024_1_E5 = 'blta20769843d377ee2';
const UID_SPARK_19_S_AT_2024_1_E5 = 'bltc97eedb40b048f8f';
const UID_SPARK_30_S_MT_2024_1_E5 = 'blt4c99fc0039fbe0de';
const UID_SPARK_4X4_30_S_MT_2024_1_E5 = 'bltabd48023be950780';

const UID_SPARK_22_B_FLAT_DECK_MT_2025_1 = 'blt57516bddb54acca8';
const UID_SPARK_22_B_CAB_CHASSIS_2025_1 = 'blt2e4ce003d4c80a5f';
const UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_MT_2025_1 = 'blt93a1890da4c903e0';
const UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_AT_2025_1 = 'bltbf552b56f5830cbc';
const UID_SPARK_22_B_MT_2025_1 = 'blt14b9be241cef08bf';
const UID_SPARK_22_S_MT_2025_1 = 'blt556e84e45728efb2';
const UID_SPARK_22_S_AT_2025_1 = 'bltef4a42d304f8e408';
const UID_SPARK_30_S_MT_2025_1 = 'blte4df1615dc9f63fa';
const UID_SPARK_4X4_30_S_MT_2025_1 = 'blt74f88a10d3c711a2';
const UID_SPARK_4X4_30_S_AT_2025_1 = 'blt73f52db0b0daac54';

export const UID_SPARK_ORDER = [
  UID_SPARK_19_B_FLAT_DECK_MT_2024_1,
  UID_SPARK_19_B_CAB_CHASSIS_MT_2024_1,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_MT_2024_1,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_AT_2024_1,
  UID_SPARK_19_B_MT_2024_1,
  UID_SPARK_19_S_MT_2024_1,
  UID_SPARK_19_S_AT_2024_1,
  UID_SPARK_30_S_MT_2024_1,
  UID_SPARK_4X4_30_S_MT_2024_1,
  UID_SPARK_19_B_FLAT_DECK_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_AT_2024_1_E5,
  UID_SPARK_19_B_MT_2024_1_E5,
  UID_SPARK_19_S_MT_2024_1_E5,
  UID_SPARK_19_S_AT_2024_1_E5,
  UID_SPARK_30_S_MT_2024_1_E5,
  UID_SPARK_4X4_30_S_MT_2024_1_E5,
  UID_SPARK_22_B_FLAT_DECK_MT_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_MT_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_AT_2025_1,
  UID_SPARK_22_B_MT_2025_1,
  UID_SPARK_22_S_MT_2025_1,
  UID_SPARK_22_S_AT_2025_1,
  UID_SPARK_30_S_MT_2025_1,
  UID_SPARK_4X4_30_S_MT_2025_1,
  UID_SPARK_4X4_30_S_AT_2025_1,
];

const UID_X_SERIES_SPEED_2_DOOR_MT_2024_1 = 'blt4a26e82422fbfad8';
export const UID_X_SERIES_SPEED_4_DOOR_MT_2024_1 = 'bltc0632807a2556b30';
const UID_X_SERIES_HILANDER_2_DOOR_MT_2024_1 = 'blt6b277ca90c5a4f1d';
const UID_X_SERIES_HILANDER_4_DOOR_MT_2024_1 = 'blt15db3361159f112f';
const UID_X_SERIES_HILANDER_4_DOOR_AT_2024_1 = 'blta93bca1990c5b1f9';

const UID_X_SERIES_SPEED_2_DOOR_MT_2024_1_E5 = 'blt8bd53bc45578b72b';
const UID_X_SERIES_SPEED_4_DOOR_MT_2024_1_E5 = 'blt79cfc7e621a118c1';
const UID_X_SERIES_HILANDER_2_DOOR_MT_2024_1_E5 = 'blt3cb320604737c7a4';
const UID_X_SERIES_HILANDER_4_DOOR_MT_2024_1_E5 = 'blt5a6ce745b7e8326c';
const UID_X_SERIES_HILANDER_4_DOOR_AT_2024_1_E5 = 'blta18576d46260ba9b';

export const UID_X_SERIES_ORDER = [
  UID_X_SERIES_SPEED_2_DOOR_MT_2024_1,
  UID_X_SERIES_SPEED_4_DOOR_MT_2024_1,
  UID_X_SERIES_HILANDER_2_DOOR_MT_2024_1,
  UID_X_SERIES_HILANDER_4_DOOR_MT_2024_1,
  UID_X_SERIES_HILANDER_4_DOOR_AT_2024_1,
  UID_X_SERIES_SPEED_2_DOOR_MT_2024_1_E5,
  UID_X_SERIES_SPEED_4_DOOR_MT_2024_1_E5,
  UID_X_SERIES_HILANDER_2_DOOR_MT_2024_1_E5,
  UID_X_SERIES_HILANDER_4_DOOR_MT_2024_1_E5,
  UID_X_SERIES_HILANDER_4_DOOR_AT_2024_1_E5,
];

export const UID_MUX_4x2_19_ACTIVE_2024_1_E5 = 'bltdb5a93fe43395b02';
export const UID_MUX_4x2_19_ELEGANT_2024_1_E5 = 'blt8d92c69f77949ca3';
export const UID_MUX_4x2_30_ELEGANT_2024_1_E5 = 'blt2a0ade9abe5e2867';
export const UID_MUX_4x2_19_ULTIMATE_2024_1_E5 = 'blte7ad063c7dac43a3';
export const UID_MUX_4x2_30_ULTIMATE_2024_1_E5 = 'blt64b4b3c707aae44b';
export const UID_MUX_4x2_30_RS_2024_1_E5 = 'blt49bf98ff0b24316a';
export const UID_MUX_4x4_30_RS_2024_1_E5 = 'blt93b3f2213253f8e1';

export const UID_MUX_4x2_22_ACTIVE_2025_1 = 'blt3634b83cdd5c6e1a';
export const UID_MUX_4x2_22_ELEGANT_2025_1 = 'bltc3de87ef75585a32';
export const UID_MUX_4x2_30_ELEGANT_2025_1 = 'blt5e1077cf7a76933c';
export const UID_MUX_4x2_22_ULTIMATE_2025_1 = 'blta49132714c476a38';
export const UID_MUX_4x2_30_ULTIMATE_2025_1 = 'blt14dd372a118c0b03';
export const UID_MUX_4x2_22_RS_2025_1 = 'blt0d4d01ef96f3c40a';
export const UID_MUX_4x2_30_RS_2025_1 = 'bltc9244600932d06ab';
export const UID_MUX_4x4_30_RS_2025_1 = 'bltd580846adf68fc7e';

export const UID_MUX_ORDER = [
  UID_MUX_4x2_19_ACTIVE_2024_1_E5,
  UID_MUX_4x2_19_ELEGANT_2024_1_E5,
  UID_MUX_4x2_30_ELEGANT_2024_1_E5,
  UID_MUX_4x2_19_ULTIMATE_2024_1_E5,
  UID_MUX_4x2_30_ULTIMATE_2024_1_E5,
  UID_MUX_4x2_30_RS_2024_1_E5,
  UID_MUX_4x4_30_RS_2024_1_E5,
  UID_MUX_4x2_22_ACTIVE_2025_1,
  UID_MUX_4x2_22_ELEGANT_2025_1,
  UID_MUX_4x2_30_ELEGANT_2025_1,
  UID_MUX_4x2_22_ULTIMATE_2025_1,
  UID_MUX_4x2_30_ULTIMATE_2025_1,
  UID_MUX_4x2_22_RS_2025_1,
  UID_MUX_4x2_30_RS_2025_1,
  UID_MUX_4x4_30_RS_2025_1,
];

export const DEFAULT_GRADE_UID_X_SERIES =
  UID_X_SERIES_SPEED_4_DOOR_MT_2024_1_E5;
export const DEFAULT_GRADE_UID_MU_X = UID_MUX_4x4_30_RS_2024_1_E5;
export const DEFAULT_GRADE_UID_V_CROSS = UID_V_CROSS_30_M_4_DOOR_MT_2024_1_E5;
export const DEFAULT_GRADE_UID_4_DOOR_HILANDER =
  UID_4_DOOR_HILANDER_30_M_AT_2024_1_E5;
export const DEFAULT_GRADE_UID_4_DOOR_CAB4 = UID_4_DOOR_CAB4_19_Z_MT_2024_1_E5;
export const DEFAULT_GRADE_UID_2_DOOR_HILANDER =
  UID_2_DOOR_HILANDER_19_ZP_AT_2024_1_E5;
export const DEFAULT_GRADE_UID_2_DOOR_SPACECAB =
  UID_2_DOOR_SPACECAB_19_L_AT_2024_1_E5;
export const DEFAULT_GRADE_UID_SPARK = UID_SPARK_4X4_30_S_MT_2024_1_E5;

const SPARK_CAB_CHASSIS = 'blt6aafd220f372f9cb';
const SPARK_CAB_CHASSIS_REFRIGERATOR = 'blta7b3821d37823ebf';
const SPARK_CAB_CHASSIS_REFRIGERATOR_AT = 'blt6fb0725abf2d8f6f';
const SPARK_FLAT_DECK_19_DDI_B = 'blt77ab9d0b8b8f4b23';

const SPARK_FLAT_DECK_19_DDI_B_2023_1 = 'blt1978c1037dd04ee2';
const SPARK_CAB_CHASSIS_2023_1 = 'bltc56492ad342eedb2';
const SPARK_CAB_CHASSIS_REGRIGERATOR_2023_1 = 'bltfdc1b512223e7260';
const SPARK_CAB_CHASSIS_REFRIGERATOR_AT_2023_1 = 'blt73ffd51229d356c0';

const SPARK_FLAT_DECK_19_DDI_B_2024_1 = 'blt2c4c007be51af6bb';
const SPARK_CAB_CHASSIS_2024_1 = 'blt429a483a8b9a061e';
const SPARK_CAB_CHASSIS_REGRIGERATOR_2024_1 = 'blt987219a8d3e53562';
const SPARK_CAB_CHASSIS_REFRIGERATOR_AT_2024_1 = 'bltb10e7f5753fb9001';

export const PRODUCT_CUSTOMIZE_SKIP_GRADE_LIST = [
  SPARK_CAB_CHASSIS,
  SPARK_CAB_CHASSIS_REFRIGERATOR,
  SPARK_CAB_CHASSIS_REFRIGERATOR_AT,
  SPARK_FLAT_DECK_19_DDI_B,
  SPARK_FLAT_DECK_19_DDI_B_2023_1,
  SPARK_CAB_CHASSIS_2023_1,
  SPARK_CAB_CHASSIS_REGRIGERATOR_2023_1,
  SPARK_CAB_CHASSIS_REFRIGERATOR_AT_2023_1,
  SPARK_FLAT_DECK_19_DDI_B_2024_1,
  SPARK_CAB_CHASSIS_2024_1,
  SPARK_CAB_CHASSIS_REGRIGERATOR_2024_1,
  SPARK_CAB_CHASSIS_REFRIGERATOR_AT_2024_1,
  UID_SPARK_19_B_FLAT_DECK_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_MT_2024_1_E5,
  UID_SPARK_19_B_CAB_CHASSIS_REFRIGERATOR_AT_2024_1_E5,
  UID_SPARK_22_B_FLAT_DECK_MT_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_MT_2025_1,
  UID_SPARK_22_B_CAB_CHASSIS_REFRIGERATOR_AT_2025_1,
];

export const MODEL_YEAR_2022_2 = '2022/2';
export const MODEL_YEAR_2023_1 = '2023/1';
export const MODEL_YEAR_2024_1 = '2024/1';
export const MODEL_YEAR_2024_1_e5 = '2024/1-e5';
export const MODEL_YEAR_2025_1 = '2025/1';
export type IModelYear =
  | typeof MODEL_YEAR_2022_2
  | typeof MODEL_YEAR_2023_1
  | typeof MODEL_YEAR_2024_1
  | typeof MODEL_YEAR_2024_1_e5
  | typeof MODEL_YEAR_2025_1;

export const HANDLE_PRODUCT_URL_BY_MODEL = (model: LcvModel) => {
  switch (model.uid) {
    case UID_MUX_4x2_19_ACTIVE_2024_1_E5:
    case UID_MUX_4x2_19_ELEGANT_2024_1_E5:
    case UID_MUX_4x2_30_ELEGANT_2024_1_E5:
    case UID_MUX_4x2_19_ULTIMATE_2024_1_E5:
    case UID_MUX_4x2_30_ULTIMATE_2024_1_E5:
    case UID_MUX_4x2_22_ACTIVE_2025_1:
    case UID_MUX_4x2_22_ELEGANT_2025_1:
    case UID_MUX_4x2_30_ELEGANT_2025_1:
    case UID_MUX_4x2_22_ULTIMATE_2025_1:
    case UID_MUX_4x2_30_ULTIMATE_2025_1:
      return (
        model.lcv_model_class[0].category[0].product_url + `?model=ultimate`
      );
  }
  return model.lcv_model_class[0].category[0].product_url;
};

export const HANDLE_REGISTER_URL_BY_MODEL = (model: LcvModel) => {
  switch (model.lcv_model_class[0].category[0].uid) {
    case MU_X_CLASS:
      return model.lcv_model_class[0].category[0].register_url + `?model=ppv`;
  }

  return model.lcv_model_class[0].category[0].register_url;
};

interface getDefaultGradeByCategoryAndModelYearParams {
  category: ILCVModelCategory | string;
  modelYear: IModelYear | string;
  subCategory?: ILCVModelSubCategory | string;
}
export const getDefaultGradeByCategoryAndModelYear = ({
  category,
  modelYear,
  subCategory,
}: getDefaultGradeByCategoryAndModelYearParams) => {
  switch (category) {
    case V_CROSS_CLASS:
      switch (modelYear) {
        case MODEL_YEAR_2024_1:
          return UID_V_CROSS_30_M_4_DOOR_MT_2024_1;
        case MODEL_YEAR_2024_1_e5:
          return UID_V_CROSS_30_M_4_DOOR_MT_2024_1_E5;
        case MODEL_YEAR_2025_1:
          return UID_V_CROSS_30_M_4_DOOR_AT_2025_1;
      }
      break;
    case PICK_UP_4_DOOR_CLASS:
      switch (subCategory) {
        case HILANDER_SUB_CATEGORY:
          switch (modelYear) {
            case MODEL_YEAR_2024_1:
              return UID_4_DOOR_HILANDER_30_M_AT_2024_1;
            case MODEL_YEAR_2024_1_e5:
              return UID_4_DOOR_HILANDER_30_M_AT_2024_1_E5;
            case MODEL_YEAR_2025_1:
              return UID_4_DOOR_HILANDER_22_M_AT_2025_1;
          }
          break;
        case CAB4_SUB_CATEGORY:
          switch (modelYear) {
            case MODEL_YEAR_2024_1:
              return UID_4_DOOR_CAB4_19_Z_MT_2024_1;
            case MODEL_YEAR_2024_1_e5:
              return UID_4_DOOR_CAB4_19_Z_MT_2024_1_E5;
            case MODEL_YEAR_2025_1:
              return UID_4_DOOR_CAB4_22_Z_MT_2025_1;
          }
          break;
      }
      break;
    case PICK_UP_2_DOOR_CLASS:
      switch (subCategory) {
        case HILANDER_SUB_CATEGORY:
          switch (modelYear) {
            case MODEL_YEAR_2024_1:
              return UID_2_DOOR_HILANDER_19_ZP_AT_2024_1;
            case MODEL_YEAR_2024_1_e5:
              return UID_2_DOOR_HILANDER_19_ZP_AT_2024_1_E5;
            case MODEL_YEAR_2025_1:
              return UID_2_DOOR_HILANDER_22_ZP_AT_2025_1;
          }
          break;
        case SPACECAB_SUB_CATEGORY:
          switch (modelYear) {
            case MODEL_YEAR_2024_1:
              return UID_2_DOOR_SPACECAB_19_L_AT_2024_1;
            case MODEL_YEAR_2024_1_e5:
              return UID_2_DOOR_SPACECAB_19_L_AT_2024_1_E5;
            case MODEL_YEAR_2025_1:
              return UID_2_DOOR_SPACECAB_22_L_AT_2025_1;
          }
          break;
      }
      break;
    case SPARK_CLASS:
      switch (modelYear) {
        case MODEL_YEAR_2024_1:
          return UID_SPARK_4X4_30_S_MT_2024_1;
        case MODEL_YEAR_2024_1_e5:
          return UID_SPARK_4X4_30_S_MT_2024_1_E5;
        case MODEL_YEAR_2025_1:
          return UID_SPARK_22_S_AT_2025_1;
      }
      break;
    case X_SERIES_CLASS:
      switch (modelYear) {
        case MODEL_YEAR_2024_1:
          return UID_X_SERIES_SPEED_4_DOOR_MT_2024_1;
        case MODEL_YEAR_2024_1_e5:
          return UID_X_SERIES_SPEED_4_DOOR_MT_2024_1_E5;
      }
    case MU_X_CLASS:
      switch (modelYear) {
        case MODEL_YEAR_2024_1_e5:
          return UID_MUX_4x4_30_RS_2024_1_E5;
        case MODEL_YEAR_2025_1:
          return UID_MUX_4x2_22_RS_2025_1;
      }
      break;
  }
};
